module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._t("left"), _vm._v(" "), _c('div', {
    staticClass: "expand-screen",
    staticStyle: {
      "color": "#3A3A3A"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg-group-box"
  }, [_vm._t("msg-icon"), _vm._v(" "), _vm._t("right")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-841bd348","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/THeader.vue
// module id = 1409
// module chunks = 28